import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalType extends BaseModelAPI {
	static entity = 'approvaltype';
	static entityName = 'approvaltype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.interfaceName = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}